import {useTranslation} from 'react-i18next';
import getNavigationLinks from "../_sidebar/pageNavigationLinks";
import PageLayout from "@/pages/_components/Layout";
import SiteSidebar from "@/pages/workspaces/sales/SiteSidebar";
import SiteMap from "@/pages/workspaces/sales/SiteMap";
import {SalesProvider} from "@/pages/workspaces/sales/SalesContext";
import {APIProvider} from '@vis.gl/react-google-maps';
import {useConfig} from '@lore/config';
import {LanguageIcon as LanguageSwitcherIcon} from '@heroicons/react/24/outline';

export default function Layout(props) {
  const {t, i18n} = useTranslation();
  const pageLinks = getNavigationLinks()
  const config = useConfig();
  const apiKey = config.google.mapApiKey;

  function handleToggleLanguage() {
    i18n.changeLanguage(i18n.language === 'en' ? 'es' : 'en');
  }
  return (
    <SalesProvider>
      <button id="language-switcher" className="absolute top-4 right-4" onClick={handleToggleLanguage} title={i18n.language}><LanguageSwitcherIcon className="rounded-full w-6 h-6 p-1 text-white hover:bg-black"/></button>

      <APIProvider apiKey={apiKey}>
        <PageLayout
          title={t('Sales')}
          breadcrumbs={[t('Workspace')]}
          subhead={t('workspace.sales.title')}
          description={t('workspace.sales.description')}
          pageLinks={pageLinks}
        >
          <div className="flex gap-2 w-full">
            <div className="w-1/5 bg-base-100 p-4 rounded-lg space-y-4 min-w-72">
              <SiteSidebar/>
            </div>

            <div className="w-4/5 bg-base-100 p-4 rounded-lg flex flex-col gap-2 min-w-[675px]">
              <SiteMap/>
            </div>
          </div>
        </PageLayout>
      </APIProvider>
    </SalesProvider>
  );
}
